import React, { useEffect, useState } from "react";
import "./Customer.css";
import { fetchDrivers } from "../../services/driverService.js";
import { getCustomerById, getCustomerLapTimes } from "../../services/customerService";
import DriverImg from "../../components/images/driver.jpg";
import SignatureRaceExperienceImg from "../../components/images/Signature Race Experience@2x.png";
import PaddockNMember from "../../components/images/Paddock Membership@2x.png";
import PaddockClubNight from "../../components/images/Paddock_Club_Button.webp";
import BronzeMember from "../../components/images/Bronze Membership@2x.png";
import GoldMember from "../../components/images/Gold Membership@2x.png";
import SilverMember from "../../components/images/Silver Membership@2x (1).png";
import LogoCard from "../../components/images/logoCard.webp";
import MemberBreakdown from "../../components/images/membership.png";

export default function Customer({ apiKey }) {
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [id, setId] = useState("");
  const [memberId, setMemberId] = useState("none");
  const [percentOff, setPercentOff] = useState("");
  const [remainingUses, setRemainingUses] = useState(null);
  const [customerData, setCustomerData] = useState(null);
  const [lapTimes, setLapTimes] = useState([]);
  const [drivers, setDrivers] = useState([]);
  const [error, setError] = useState(null);
  const [renewaldate, setRenewalDate] = useState(null);
  const [previewNewFeature, setPreviewNewFeature] = useState(false);
  const [discountCodeDisplay, setDiscountCodeDisplay] = useState("none");

  const memberships = [
    {
      name: "Bronze Membership",
      link: "https://onelineracing.com/products/p3-membership",
      price: "19.99 after 1st month",
      benefits: ["1 Free Signature Race Per Month", "20% Discount on all Signature Races"],
      image: BronzeMember,
    },
    {
      name: "Silver Membership",
      link: "https://onelineracing.com/products/silver-membership",
      price: "89",
      benefits: ["3 Free Signature Races Per Month", "25% Discount on all Signature Races"],
      image: SilverMember,
    },
    {
      name: "Gold Membership",
      link: "https://onelineracing.com/products/gold-membership",
      price: "199",
      benefits: ["8 Free Signature Races Per Month", "30% Discount on all Signature Races"],
      image: GoldMember,
    },
    {
      name: "Paddock Membership",
      link: "https://onelineracing.com/products/paddock-membership",
      price: "299",
      benefits: ["10 Free Signature Races Per Month", "40% Discount on all Signature Races"],
      image: PaddockNMember,
    },
  ];

  useEffect(() => {
    const queryParams = new URLSearchParams(window.location.search);

    // Get the raw next_billing_date from URL
    const rawRenewalDate = queryParams.get("next_billing_date");

    if (rawRenewalDate && rawRenewalDate !== "N/A") {
      // Manually reformat from YYYY-MM-DD to MM/DD/YY
      const [year, month, day] = rawRenewalDate.split("-");
      const formattedDate = `${month}/${day}/${year.slice(2)}`;
      setRenewalDate(formattedDate);
    } else {
      setRenewalDate("N/A");
    }

    // Get the discount_code from URL
    const discountCodeFromUrl = queryParams.get("discount_code");
    if (discountCodeFromUrl && discountCodeFromUrl !== "none") {
      const extractedCode = discountCodeFromUrl.replace("discount_code_", "");
      setDiscountCodeDisplay(extractedCode);
    } else {
      setDiscountCodeDisplay("none");
    }

    const firstNameFromUrl = queryParams.get("first_name");
    const lastNameFromUrl = queryParams.get("last_name");
    const emailFromUrl = queryParams.get("email");
    const idFromUrl = queryParams.get("id");
    const memberIdFromUrl = queryParams.get("member");
    const percentOffFromUrl = queryParams.get("percentage");
    const tagFromUrl = queryParams.get("tag");
    const renewalDate = queryParams.get("next_billing_date");
    const previewNewFeature = queryParams.get("preview_feature");
    // setRenewalDate(renewalDate);
    setPreviewNewFeature(previewNewFeature);

    if (!firstNameFromUrl || !lastNameFromUrl) {
      setError("Please Login");
      return;
    }

    setFirstName(firstNameFromUrl);
    setLastName(lastNameFromUrl);
    setEmail(emailFromUrl || "N/A");
    setId(idFromUrl || "N/A");
    setMemberId(memberIdFromUrl || "none");
    setPercentOff(percentOffFromUrl || "0");

    // If tag indicates "discount_uses_remaining_x", parse out 'x'
    if (tagFromUrl && tagFromUrl.startsWith("discount_uses_remaining_")) {
      const remaining = parseInt(tagFromUrl.split("_").pop(), 10);
      setRemainingUses(!isNaN(remaining) ? remaining : "N/A");
    } else {
      setRemainingUses("N/A");
    }

    const customerName = `${firstNameFromUrl} ${lastNameFromUrl}`.trim();

    const loadCustomerData = async () => {
      try {
        const { data, error } = await fetchDrivers(process.env.REACT_APP_API_KEY);
        if (error) {
          setError(error);
          return;
        }

        setDrivers(data);

        // Find the matching driver object by name
        const driver = data.find((d) => d.name.trim().toLowerCase() === customerName.toLowerCase());
        if (!driver) {
          // If no driver found, it sets error - but you might just want to skip error
          setError("Customer not found.");
          return;
        }

        // If driver is found, fetch more details
        const customerDetails = await getCustomerById(driver.id);
        setCustomerData(customerDetails);

        const customerLaps = await getCustomerLapTimes(driver.id);
        setLapTimes(customerLaps);
      } catch (err) {
        console.error("Error loading customer data:", err);
        setError("An error occurred. Please try again.");
      }
    };

    loadCustomerData();
  }, [apiKey]);

  const titleName = `${memberId && memberId.includes("-") ? memberId.split("-")[0].toUpperCase() : ""}${firstName ? firstName[0].toUpperCase() : ""}${lastName || ""}`;
  const discountCode = titleName;

  // =====================================
  // CASE 1: No membership at all and no customer data
  // =====================================
  if (memberId === "none" && !customerData) {
    return (
      <div className="membership-options">
        <h1 style={{ textAlign: "center", margin: "20px 0", fontWeight: "300" }}>Join a Membership Plan</h1>
        <h3 style={{ textAlign: "center", margin: "20px 0", fontWeight: "300", color: "white" }}>Already a member? Click the Login Icon at the top of the page.</h3>
        <div className="membership-breakdown__holder">
          <img className="membership-breakdown" src={MemberBreakdown} />
        </div>
        <div className="driver-demo-card__holder">
          <div className="card">
            <img className="card-img-top" src={DriverImg} alt="Driver" />
            <div className="card-body">
              <div className="card-title h5 text-center">YOUR NAME</div>
              <div className="row">
                <div className="col-6">
                  <div className="text-value">SIGN UP</div>
                  <small className="text-uppercase text-muted">Member</small>
                  <div className="text-value">YOUR INFO HERE</div>
                  <small className="text-uppercase text-muted">Last Circuit</small>
                </div>
                <div className="col-6">
                  <div className="text-value">YOUR INFO HERE</div>
                  <small className="text-uppercase text-muted">Laps Recorded</small>
                  <div className="text-value">YOUR INFO HERE</div>
                  <small className="text-uppercase text-muted">Last Vehicle</small>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="membership-card-container" style={{ display: "flex", flexWrap: "wrap", justifyContent: "center" }}>
          {memberships.map((membership, index) => (
            <div
              key={index}
              className="membership-card"
              style={{
                margin: "15px",
                width: "250px",
                textAlign: "left",
                border: "1px solid #ccc",
                borderRadius: "8px",
                padding: "15px",
                fontFamily: "BankGothicBT-Medium",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              <img src={membership.image} alt={membership.name} style={{ width: "100%", borderRadius: "8px" }} />

              <p>{membership.benefits[0]}</p>
              <p>{membership.benefits[1]}</p>
              <a
                href={membership.link}
                target="_blank"
                rel="noopener noreferrer"
                className="red-button"
                style={{
                  padding: "10px 15px",
                  // background: "linear-gradient(180deg, #1093CE 0%, #0E4465 100%);",
                  color: "#fff",
                  textDecoration: "none",
                  borderRadius: "5px",
                }}
              >
                Get {membership.name}
              </a>
            </div>
          ))}
        </div>
      </div>
    );
  }

  // =====================================
  // CASE 2: We do have a membership but NO customerData
  // (memberId !== "none" && !customerData)
  // =====================================
  if (memberId !== "none" && !customerData) {
    return (
      <div className="customer-container">
        <br />
        <h1>
          Hi, {firstName} <br />
          <br /> Thanks for being a {memberId} Member!
        </h1>
        {/* Placeholder driver card */}
        <div className="driver-demo-card__holder">
          <div className="card">
            <img className="card-img-top" src={DriverImg} alt="Driver" />
            <div className="card-body">
              <div className="card-title h5 text-center">YOUR NAME</div>
              <div className="row">
                <div className="col-6">
                  <div className="text-value">{memberId ? memberId.charAt(0).toUpperCase() + memberId.slice(1) : ""}</div>
                  <small className="text-uppercase text-muted">Member</small>
                  <div className="text-value">-- circuit --</div>
                  <small className="text-uppercase text-muted">Last Circuit</small>
                </div>
                <div className="col-6">
                  <div className="text-value">-- laps --</div>
                  <small className="text-uppercase text-muted">Laps Recorded</small>
                  <div className="text-value">-- vehicle --</div>
                  <small className="text-uppercase text-muted">Last Vehicle</small>
                </div>
              </div>
              <p style={{ fontSize: "14px", textAlign: "center", fontStyle: "italic", fontFamily: "helvetica", fontWeight: "800" }}>
                Log your first race <br />
                <br /> and your stats will show here
              </p>
            </div>
          </div>
          <div className="customer__nav_holder">
            <a href="#credits-section">
              <p className="red-button__nav">My Passes</p>
            </a>

            <a href="#special-events-section">
              <p className="red-button__nav">Special Events</p>
            </a>
          </div>
        </div>
        <div className="perks-container">
          <h1 id="credits-section">Your Passes : {remainingUses}</h1>
          <div className="perks-card-holder">
            {/* Product Cards */}
            <div className="product-card">
              <img src={SignatureRaceExperienceImg} alt="Free 1 Hour Signature Race Experience" />
              <p>
                <a
                  href="https://onelineracing.com/products/test-discount-1-hour-signature-race-experience"
                  className={`red-button ${remainingUses === 0 ? "disabled" : ""}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{
                    pointerEvents: remainingUses === 0 ? "none" : "auto",
                    backgroundColor: remainingUses === 0 ? "#ccc" : "linear-gradient(180deg, #1093CE 0%, #0E4465 100%);",
                    color: remainingUses === 0 ? "#666" : "#fff",
                  }}
                >
                  Use My Free Race Passes ({remainingUses})
                </a>
              </p>
              <p>
                Your unique code:{" "}
                <strong
                  style={{ cursor: "pointer", textDecoration: "underline" }}
                  onClick={() => {
                    const uniqueCode =
                      discountCodeDisplay !== "none"
                        ? discountCodeDisplay
                        : `${memberId ? memberId.charAt(0).toUpperCase() + memberId.slice(1) : ""}${firstName[0].toUpperCase()}${lastName ? lastName.charAt(0).toUpperCase() + lastName.slice(1) : ""}`;
                    navigator.clipboard
                      .writeText(uniqueCode)
                      .then(() => alert("Copied to clipboard!"))
                      .catch((err) => console.error("Failed to copy: ", err));
                  }}
                >
                  {discountCodeDisplay !== "none"
                    ? discountCodeDisplay
                    : `${memberId ? memberId.charAt(0).toUpperCase() + memberId.slice(1) : ""}${firstName[0].toUpperCase()}${lastName ? lastName.charAt(0).toUpperCase() + lastName.slice(1) : ""}`}
                </strong>
              </p>

              <p>Renews On: {renewaldate}</p>
              <p style={{ fontSize: "10px", fontStyle: "italic" }}>
                *Currently our system is only able to use free race Passe 1 booking at a time. If you'd like to use your free race Passes for multiple seats in the same time slot (guest passes),
                please proceed with individual transactions per seat.
              </p>
              {remainingUses === 0 && (
                <p className="no-credits" style={{ color: "red" }}>
                  You have no remaining Passes
                </p>
              )}
            </div>

            <div className="product-card">
              <img src={SignatureRaceExperienceImg} alt="Free 1 Hour Signature Race Experience" />
              <p>
                <a href="https://onelineracing.com/products/one-hour-race-session" className="red-button" target="_blank" rel="noopener noreferrer">
                  BOOK NOW
                </a>
              </p>
              <p>
                Enjoy {percentOff}% off with your {memberId ? memberId.charAt(0).toUpperCase() + memberId.slice(1) : ""} Membership!
              </p>
            </div>
            {/* Paddock Night Card */}
            {(memberId.includes("paddock") || memberId.includes("Paddock") || memberId.includes("founding")) && (
              <div className="product-card">
                <img src={PaddockClubNight} alt="Free 1 Hour Signature Race Experience" />
                <p>
                  <a href="https://onelineracing.com/products/paddock-club-night" className="red-button" target="_blank" rel="noopener noreferrer">
                    BOOK NOW
                  </a>
                </p>
                <p>Book your Paddock Club Night</p>
              </div>
            )}
          </div>
          <h1 id="special-events-section">Special Events</h1>
          <h3 style={{ color: "white", textAlign: "center" }}>Please call us to use partial credit towards an event</h3>
          <div className="events-holder">
            <div className="event-cards">
              {/* 1 Hour Special Event */}
              <div className="product-card">
                <img src={LogoCard} alt="1 Hour Special Event" />
                <h3>1 Hour Special Event</h3>
                {remainingUses > 0 ? (
                  <p>
                    <a href="https://onelineracing.com/products/1-hour-special-event" className="red-button" target="_blank" rel="noopener noreferrer">
                      BOOK NOW with 1 Pass ({remainingUses})
                    </a>
                  </p>
                ) : (
                  <h4 style={{ color: "red" }}>You need {Math.max(1 - remainingUses, 0)} more Pass</h4>
                )}
              </div>

              {/* 2 Hour Special Event */}
              <div className="product-card">
                <img src={LogoCard} alt="2 Hour Special Event" />
                <h3>2 Hour Special Event</h3>
                {remainingUses > 1 ? (
                  <p>
                    <a href="https://onelineracing.com/products/2-hour-special-event" className="red-button" target="_blank" rel="noopener noreferrer">
                      BOOK NOW with 2 Passes ({remainingUses})
                    </a>
                  </p>
                ) : (
                  <h4 style={{ color: "red" }}>You need {Math.max(2 - remainingUses, 0)} more Passes</h4>
                )}
              </div>

              {/* 4 Hour Special Event */}
              <div className="product-card">
                <img src={LogoCard} alt="4 Hour Special Event" />
                <h3>4 Hour Special Event</h3>
                {remainingUses > 3 ? (
                  <p>
                    <a href="https://onelineracing.com/products/4-hour-special-event" className="red-button" target="_blank" rel="noopener noreferrer">
                      BOOK NOW with 4 Passes ({remainingUses})
                    </a>
                  </p>
                ) : (
                  <h4 style={{ color: "red" }}>You need {Math.max(4 - remainingUses, 0)} more Passes</h4>
                )}
              </div>
            </div>
          </div>
        </div>

        <h1 style={{ textAlign: "center", marginTop: "20px", fontSize: "1.5rem" }}>
          Need help or want to update your membership?{" "}
          <a href="mailto:info@onelineracing.com" style={{ color: "linear-gradient(180deg, #1093CE 0%, #0E4465 100%);", textDecoration: "underline" }}>
            Email us!
          </a>
        </h1>
      </div>
    );
  }

  // =====================================
  // CASE 3: We don't have a membership but has customerData
  // =====================================
  if (memberId === "none" && customerData) {
    return (
      <div className="customer-container">
        {/* "Hi, {firstName}"  */}
        <h1>
          Hi, {firstName} <br />
          <br />
          Here are the available Memberships
        </h1>

        {/* Product Cards */}
        <div className="membership-card-container" style={{ display: "flex", flexWrap: "wrap", justifyContent: "center" }}>
          {memberships.map((membership, index) => (
            <div
              key={index}
              className="membership-card"
              style={{
                margin: "15px",
                width: "250px",
                textAlign: "left",
                border: "1px solid #ccc",
                borderRadius: "8px",
                padding: "15px",
                fontFamily: "BankGothicBT-Medium",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              <img src={membership.image} alt={membership.name} style={{ width: "100%", borderRadius: "8px" }} />

              <p>{membership.benefits[0]}</p>
              <p>{membership.benefits[1]}</p>
              <a
                href={membership.link}
                target="_blank"
                rel="noopener noreferrer"
                className="red-button"
                style={{
                  padding: "10px 15px",
                  backgroundColor: "linear-gradient(180deg, #1093CE 0%, #0E4465 100%);",
                  color: "#fff",
                  textDecoration: "none",
                  borderRadius: "5px",
                }}
              >
                Get {membership.name}
              </a>
            </div>
          ))}
        </div>

        {/* DRIVER CARD */}
        <div className="driver-card-holder">
          <div className="card">
            <img className="card-img-top" src={DriverImg} alt="Driver" />
            <div className="card-body">
              <div className="card-title h5 text-center">{customerData.name}</div>
              <div className="row">
                <div className="col-6">
                  <div className="text-value">{customerData.driverClass}</div>
                  <small className="text-uppercase text-muted">Not a Member</small>
                  <div className="text-value">{customerData.lastCircuit}</div>
                  <small className="text-uppercase text-muted">Last Circuit</small>
                </div>
                <div className="col-6">
                  <div className="text-value">{customerData.lapsRecorded}</div>
                  <small className="text-uppercase text-muted">Laps Recorded</small>
                  <div className="text-value">{customerData.lastVehicle}</div>
                  <small className="text-uppercase text-muted">Last Vehicle</small>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* DRIVER CARD */}
        <div
          style={{
            width: "100%",
            display: "flex",
            justifyContent: "center",
            alignContent: "center",
          }}
        >
          <h1>Your Stats</h1>
        </div>
        <table className="customer-lap-table">
          <thead>
            <tr>
              <th>Circuit</th>
              <th>Vehicle</th>
              <th>Date</th>
              <th>Time</th>
              <th></th> {/* Telemetry link */}
              <th>S1</th>
              <th>S2</th>
              <th>S3</th>
            </tr>
          </thead>
          <tbody>
            {lapTimes.map((lap, index) => (
              <tr key={index}>
                <td>{lap.circuit_name}</td>
                <td>{lap.vehicle_name}</td>
                <td>{new Date(lap.date).toLocaleDateString("en-US")}</td>
                <td>{lap.lap_time_str}</td>
                <td>
                  <a href={lap.telemetry_uri} target="_blank" rel="noopener noreferrer">
                    <svg
                      aria-hidden="true"
                      focusable="false"
                      data-prefix="fas"
                      data-icon="chart-line"
                      className="svg-inline--fa fa-chart-line fa-w-16"
                      role="img"
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 512 512"
                      style={{ width: "16px", height: "16px" }}
                    >
                      <path
                        fill="currentColor"
                        d="M496 384H64V80c0-8.84-7.16-16-16-16H16C7.16 
                          64 0 71.16 0 80v336c0 17.67 14.33 32 32 32h464c8.84 
                          0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16zM464 
                          96H345.94c-21.38 0-32.09 25.85-16.97 
                          40.97l32.4 32.4L288 242.75l-73.37-73.37c-12.5-12.5-32.76-12.5-45.25 
                          0l-68.69 68.69c-6.25 6.25-6.25 16.38 0 
                          22.63l22.62 22.62c6.25 6.25 16.38 6.25 22.63 
                          0L192 237.25l73.37 73.37c12.5 12.5 32.76 
                          12.5 45.25 0l96-96 32.4 32.4c15.12 15.12 
                          40.97 4.41 40.97-16.97V112c.01-8.84-7.15-16-15.99-16z"
                      ></path>
                    </svg>
                  </a>
                </td>
                <td>{lap.split1_str}</td>
                <td>{lap.split2_str}</td>
                <td>{lap.split3_str}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    );
  }

  // =====================================
  // CASE 4: We do have a membership and we DO have customerData
  // (the original "happy path")
  // =====================================

  // If there's an error, show it
  if (error) {
    return <div className="customer-error">{error}</div>;
  }

  // If we're still loading but membership isn't "none," we might show:
  if (!customerData) {
    return <div className="customer-loading">Loading customer data...</div>;
  }

  // Otherwise, show the actual data
  return (
    <div className="customer-container">
      <br />
      <h1>
        Hi, {firstName} <br />
        <br /> Thanks for being a {memberId} Member!
      </h1>
      {/* Driver Card */}
      <div className="driver-card-holder">
        <div className="card">
          <img className="card-img-top" src={DriverImg} alt="Driver" />
          <div className="card-body">
            <div className="card-title h5 text-center">{customerData.name}</div>
            <div className="row">
              <div className="col-6">
                <div className="text-value">{customerData.driverClass}</div>
                <small className="text-uppercase text-muted">{memberId ? memberId.charAt(0).toUpperCase() + memberId.slice(1) : ""} Member</small>
                <div className="text-value">{customerData.lastCircuit}</div>
                <small className="text-uppercase text-muted">Last Circuit</small>
              </div>
              <div className="col-6">
                <div className="text-value">{customerData.lapsRecorded}</div>
                <small className="text-uppercase text-muted">Laps Recorded</small>
                <div className="text-value">{customerData.lastVehicle}</div>
                <small className="text-uppercase text-muted">Last Vehicle</small>
              </div>
            </div>
          </div>
        </div>
        <div className="customer__nav_holder">
          <a href="#credits-section">
            <p className="red-button__nav">My Passes</p>
          </a>

          <a href="#special-events-section">
            <p className="red-button__nav">Special Events</p>
          </a>

          <a href="#your-stats">
            <p className="red-button__nav">My Stats</p>
          </a>
        </div>
      </div>
      <div className="perks-container">
        <h1 id="credits-section">Your Passes : {remainingUses}</h1>
        <div className="perks-card-holder">
          {/* Product Cards */}
          <div className="product-card">
            <img src={SignatureRaceExperienceImg} alt="Free 1 Hour Signature Race Experience" />
            <p>
              <a
                href="https://onelineracing.com/products/test-discount-1-hour-signature-race-experience"
                className={`red-button ${remainingUses === 0 ? "disabled" : ""}`}
                target="_blank"
                rel="noopener noreferrer"
                style={{
                  pointerEvents: remainingUses === 0 ? "none" : "auto",
                  backgroundColor: remainingUses === 0 ? "#ccc" : "linear-gradient(180deg, #1093CE 0%, #0E4465 100%);",
                  color: remainingUses === 0 ? "#666" : "#fff",
                }}
              >
                Use My Free Race Passes ({remainingUses})
              </a>
            </p>
            <p>
              Your unique code:{" "}
              <strong
                style={{ cursor: "pointer", textDecoration: "underline" }}
                onClick={() => {
                  const uniqueCode =
                    discountCodeDisplay !== "none"
                      ? discountCodeDisplay
                      : `${memberId ? memberId.charAt(0).toUpperCase() + memberId.slice(1) : ""}${firstName[0].toUpperCase()}${lastName ? lastName.charAt(0).toUpperCase() + lastName.slice(1) : ""}`;
                  navigator.clipboard
                    .writeText(uniqueCode)
                    .then(() => alert("Copied to clipboard!"))
                    .catch((err) => console.error("Failed to copy: ", err));
                }}
              >
                {discountCodeDisplay !== "none"
                  ? discountCodeDisplay
                  : `${memberId ? memberId.charAt(0).toUpperCase() + memberId.slice(1) : ""}${firstName[0].toUpperCase()}${lastName ? lastName.charAt(0).toUpperCase() + lastName.slice(1) : ""}`}
              </strong>
            </p>

            <p>Renews On: {renewaldate}</p>
            <p style={{ fontSize: "10px", fontStyle: "italic" }}>
              *Currently our system is only able to use free race Passes 1 booking at a time. If you'd like to use your free race passes for multiple seats in the same time slot (guest passes), please
              proceed with individual transactions per seat.
            </p>
            {remainingUses === 0 && (
              <p className="no-credits" style={{ color: "red" }}>
                You have no remaining Free Passes
              </p>
            )}
          </div>

          <div className="product-card">
            <img src={SignatureRaceExperienceImg} alt="Free 1 Hour Signature Race Experience" />
            <p>
              <a href="https://onelineracing.com/products/one-hour-race-session" className="red-button" target="_blank" rel="noopener noreferrer">
                BOOK NOW
              </a>
            </p>
            <p>
              Enjoy {percentOff}% off with your {memberId ? memberId.charAt(0).toUpperCase() + memberId.slice(1) : ""} Membership!
            </p>
          </div>
          {/* Paddock Night Card */}
          {(memberId.includes("paddock") || memberId.includes("Paddock") || memberId.includes("founding")) && (
            <div className="product-card">
              <img src={PaddockClubNight} alt="Free 1 Hour Signature Race Experience" />
              <p>
                <a href="https://onelineracing.com/products/paddock-club-night" className="red-button" target="_blank" rel="noopener noreferrer">
                  BOOK NOW
                </a>
              </p>
              <p>Book your Paddock Club Night</p>
            </div>
          )}
        </div>
        <h1 id="special-events-section">Special Events</h1>
        <h3 style={{ color: "white", textAlign: "center" }}>Please call us to use partial credit towards an event</h3>
        <div className="events-holder">
          <div className="event-cards">
            {/* 1 Hour Special Event */}
            <div className="product-card">
              <img src={LogoCard} alt="1 Hour Special Event" />
              <h3>1 Hour Special Event</h3>
              {remainingUses > 0 ? (
                <p>
                  <a href="https://onelineracing.com/products/1-hour-special-event" className="red-button" target="_blank" rel="noopener noreferrer">
                    BOOK NOW with 1 Pass ({remainingUses})
                  </a>
                </p>
              ) : (
                <h4 style={{ color: "red" }}>You need {Math.max(1 - remainingUses, 0)} more Passes</h4>
              )}
            </div>

            {/* 2 Hour Special Event */}
            <div className="product-card">
              <img src={LogoCard} alt="2 Hour Special Event" />
              <h3>2 Hour Special Event</h3>
              {remainingUses > 1 ? (
                <p>
                  <a href="https://onelineracing.com/products/2-hour-special-event" className="red-button" target="_blank" rel="noopener noreferrer">
                    BOOK NOW with 2 Passes ({remainingUses})
                  </a>
                </p>
              ) : (
                <h4 style={{ color: "red" }}>You need {Math.max(2 - remainingUses, 0)} more Passes</h4>
              )}
            </div>

            {/* 4 Hour Special Event */}
            <div className="product-card">
              <img src={LogoCard} alt="4 Hour Special Event" />
              <h3>4 Hour Special Event</h3>
              {remainingUses > 3 ? (
                <p>
                  <a href="https://onelineracing.com/products/4-hour-special-event" className="red-button" target="_blank" rel="noopener noreferrer">
                    BOOK NOW with 4 Passes ({remainingUses})
                  </a>
                </p>
              ) : (
                <h4 style={{ color: "red" }}>You need {Math.max(4 - remainingUses, 0)} more Passes</h4>
              )}
            </div>
          </div>
        </div>
      </div>
      <h1 style={{ textAlign: "center", marginTop: "20px", fontSize: "1.5rem" }}>
        Need help or want to update your membership?{" "}
        <a href="mailto:info@onelineracing.com" style={{ color: "linear-gradient(180deg, #1093CE 0%, #0E4465 100%);", textDecoration: "underline" }}>
          Email us!
        </a>
      </h1>
      <div
        style={{
          width: "100%",
          display: "flex",
          justifyContent: "center",
          alignContent: "center",
        }}
      >
        <h1 id="your-stats">Your Stats</h1>
      </div>
      <table className="customer-lap-table">
        <thead>
          <tr>
            <th>Circuit</th>
            <th>Vehicle</th>
            <th>Date</th>
            <th>Time</th>
            <th></th> {/* Telemetry link */}
            <th>S1</th>
            <th>S2</th>
            <th>S3</th>
          </tr>
        </thead>
        <tbody>
          {lapTimes.map((lap, index) => (
            <tr key={index}>
              <td>{lap.circuit_name}</td>
              <td>{lap.vehicle_name}</td>
              <td>{new Date(lap.date).toLocaleDateString("en-US")}</td>
              <td>{lap.lap_time_str}</td>
              <td>
                <a href={lap.telemetry_uri} target="_blank" rel="noopener noreferrer">
                  <svg
                    aria-hidden="true"
                    focusable="false"
                    data-prefix="fas"
                    data-icon="chart-line"
                    className="svg-inline--fa fa-chart-line fa-w-16"
                    role="img"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 512 512"
                    style={{ width: "16px", height: "16px" }}
                  >
                    <path
                      fill="currentColor"
                      d="M496 384H64V80c0-8.84-7.16-16-16-16H16C7.16 
                          64 0 71.16 0 80v336c0 17.67 14.33 32 32 32h464c8.84 
                          0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16zM464 
                          96H345.94c-21.38 0-32.09 25.85-16.97 
                          40.97l32.4 32.4L288 242.75l-73.37-73.37c-12.5-12.5-32.76-12.5-45.25 
                          0l-68.69 68.69c-6.25 6.25-6.25 16.38 0 
                          22.63l22.62 22.62c6.25 6.25 16.38 6.25 22.63 
                          0L192 237.25l73.37 73.37c12.5 12.5 32.76 
                          12.5 45.25 0l96-96 32.4 32.4c15.12 15.12 
                          40.97 4.41 40.97-16.97V112c.01-8.84-7.15-16-15.99-16z"
                    ></path>
                  </svg>
                </a>
              </td>
              <td>{lap.split1_str}</td>
              <td>{lap.split2_str}</td>
              <td>{lap.split3_str}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
